import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Router,ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ContactService } from './../../services/contact.service';
import { EncrDecrService } from '../../services/encr-decr.service';

@Component({
  selector: 'app-edit-customer',
  templateUrl: './edit-customer.component.html',
  styleUrls: ['./edit-customer.component.css']
})

export class EditCustomerComponent implements OnInit {
  user_id: any='';
  company_id: any='';
  contact_id: any='';
  APIKEY:any= '';
  model: any = { }; 
  arrayOne(n: number): any[] {
    return Array(n);
  }
  biiling_read_only=false;
  biiling_mode=false;
  assign_fact_mode1=false;
  assign_fact_mode2=false;
  assign_fact_mode3=false;
  div1:boolean=true;
  div2:boolean=false;
  div3:boolean=true;

  constructor(    
    private _contact:ContactService,
    private EncrDecr: EncrDecrService,
    private _router : Router,
    private toastr: ToastrService,
    private _activatedroute: ActivatedRoute
    ) { }

  ngOnInit() {
    this.APIKEY =localStorage.getItem('APIKEY');
    this.user_id =localStorage.getItem('id'),
    this._activatedroute.params.subscribe(params => {
      this.company_id= this.EncrDecr.get(localStorage.getItem('key'), params['id']);
    });
   
    this.model= { 
       APIKEY : this.APIKEY,
       user_id : this.user_id,
       company_id : this.company_id
    };

    this.model["terms"] ='';
    this.model["status"] ='active';

    this._activatedroute.params.subscribe(params => {
      this.contact_id = this.EncrDecr.get(localStorage.getItem('key'), params['id']);
    });

    this.get_company_by_id();
  }

  onChange(divvalue,e){
    if(divvalue=='div1') {
      if(e.target.checked) {
        this.div2=true; this.div3=false; 
      } else {
         this.div3=true;this.div2=false;
      } 
    }
 
   if(divvalue=='div3'){
     if(e.target.checked){
       this.div3=true; this.div2=false;
     }else{
       this.div1=true;this.div2=false;
     }
   }
 }

  onSubmit(form) {
     this._contact.updateContact(this.model)
     .subscribe(
       res => {  
          if(res.status==true){
            this.toastr.success(res.message, 'Success');
            this._router.navigate(['/customer/customer-list/active']);
          }
          else{
            this.toastr.error(res.message, 'Error');
          }
       }
     );
  }

  AssignFact(value){
    this.model["assign_fact"] =value;
  }

  public setBillingMode(value:boolean){  
    if(value==true){
      
      this.model["same_as_check"] ='yes';
      this.model["bill_address1"] = this.model["main_address1"];
      this.model["bill_address2"] = this.model["main_address2"];
      this.model["bill_country"] = this.model["main_country"];
      this.model["bill_city"] = this.model["main_city"];
      this.model["bill_state"] = this.model["main_state"];
      this.model["bill_zip"] = this.model["main_zip"];
      this.biiling_read_only=true;
    }
    else{
      this.model["same_as_check"] ='no';
      this.model["bill_address1"] = '';
      this.model["bill_address2"] = '';
      this.model["bill_country"] = '';
      this.model["bill_city"] = '';
      this.model["bill_state"] = '';
      this.model["bill_zip"] = '';
      this.biiling_read_only=false;
    }    
  }

  get_company_by_id(){
     const data = {
       company_id:this.contact_id,
       APIKEY : this.APIKEY
     }
     // get customer  Details
      this._contact.getContactByid(data)
       .subscribe(
         res => {
          this.model["company_id"] =this.company_id;
          this.model["customer_id"] =res.data.customer_id;
          this.model["customer_no"] =res.data.customer_no;
          this.model["company_name"] =res.data.company_name;
          this.model["contact_name"] =res.data.contact_name;
          this.model["phone_number"] =res.data.phone_number;
          this.model["mobile_number"] =res.data.mobile_number;
          this.model["extension"] =res.data.extension;
          this.model["email"] =res.data.email;
          this.model["ccemail"] =res.data.ccemail;
          this.model["creditlimit"] =res.data.creditlimit;
          this.model["terms"] =res.data.terms;
          this.model["assign_fact"] =res.data.assign_fact;
       
          this.model["status"] =res.data.status;
          this.model["billing_email"] =res.data.billing_email;
          
          //added this line by deepak on 15/07/2022
          this.model["noa_on_every_invoice"] =res.data.noa_on_every_invoice;

          if(res.data.same_as_check=='yes'){
            this.biiling_read_only=true;
            this.biiling_mode=true;
          }

          if(res.data.assign_fact== 1){
              this.assign_fact_mode1=true; 
              this.assign_fact_mode2=false;
              this.assign_fact_mode3=false; 
          }
          else if(res.data.assign_fact==2){
             this.assign_fact_mode2=true; 
             this.assign_fact_mode1=false; 
             this.assign_fact_mode3=false; 
          
          }
          else{
              this.assign_fact_mode3=true;
              this.assign_fact_mode2=false; 
              this.assign_fact_mode1=false;  
          }
      },
         err => console.log(err)
      );
     
      ///get customer address by type 
      const main = {
        module_id:this.contact_id,
        address_type:'main',
        module_type:'customer',
        APIKEY : this.APIKEY
      } 
      this._contact.getContactaddressByid(main)
       .subscribe(
        addres => {
        this.model["main_address1"] =addres.data.address1;
        this.model["main_address2"] =addres.data.address2;
        this.model["main_country"] =addres.data.country;
        this.model["main_city"] =addres.data.city;
        this.model["main_state"] =addres.data.state;
        this.model["main_zip"] =addres.data.zip;
        // this.model=res.data;
      },
         err => console.log(err)
      );
      const billing = {
        module_id:this.contact_id,
        address_type:'biiling',
        module_type:'customer',
        APIKEY : this.APIKEY
      } 
      this._contact.getContactaddressByid(billing)
       .subscribe(
        billingres => {
        this.model["bill_address1"] =billingres.data.address1;
        this.model["bill_address2"] =billingres.data.address2;
        this.model["bill_country"] =billingres.data.country;
        this.model["bill_city"] =billingres.data.city;
        this.model["bill_state"] =billingres.data.state;
        this.model["bill_zip"] =billingres.data.zip;
      },
         err => console.log(err)
      );

    } 

    
  public assign_fact_NoStamp(value) {
    this.model["assign_fact"] = value;
  }



}
